import React from "react";
import "./EmptyState.css";

const EmptyState = ({
  icon: Icon,
  title,
  description,
  buttonText,
  onButtonClick,
  iconSize = 64,
  iconColor = "var(--color-grey)",
  style = {},
}) => {
  return (
    <div className="emptyState" style={style}>
      {Icon && (
        <div className="emptyState__icon">
          <Icon size={iconSize} color={iconColor} />
        </div>
      )}
      <h2 className="emptyState__title">{title}</h2>
      <p className="emptyState__description">{description}</p>
      {buttonText && onButtonClick && (
        <button className="emptyState__button" onClick={onButtonClick}>
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
